import axios from 'axios'

const httpClient = axios.create({
  baseURL: '/',
  timeout: 10000,
  headers: {
    // This is just a default that can be overridden
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// NOTE: This CSRF handling is also implemented in application.js as part of the root Vue app
// but this httpClient pattern should be used going forward and eventually replace it
httpClient.interceptors.request.use(
  config => {
    // Add CSRF token to the request
    // Use safe navigation because test envs don't have a CSRF token by default
    const token = document.getElementsByName('csrf-token')[0]?.getAttribute('content')
    config.headers['X-CSRF-Token'] = token

    // If we're sending a FormData object, we need to set the content type to multipart/form-data
    if (config.data instanceof FormData) {
      // This overwrites the default application/json content type set above
      config.headers['Content-Type'] = 'multipart/form-data'
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default httpClient
